import React, { useRef } from 'react';
import { useVideo } from './hook';
import Progress from 'rsuite/Progress';

export default function OptionVideo(props) {
  const { video: { poster, items } } = props;
  const videRef = useRef();
  const [
    percent,
    playing,
    onPlay,
    onPause,
    onEnded,
    onTimeupdate
  ] = useVideo(videRef.current);

  return (
    <div className={`app-option-video ${playing ? 'is-playing': ''}`}>
      <video
        muted
        preload="none"
        ref={videRef}
        poster={poster}
        onPause={onPause}
        onTimeUpdate={onTimeupdate}
        onEnded={onEnded}>
        {items.map((item, itemIndex) => (
          <source
            key={itemIndex}
            src={item.path}
            type={item.type}
          />
        ))}
        Your browser does not support the video tag.
      </video>
      <Progress.Line
        percent={percent}
        strokeColor="#0286db"
        showInfo={false}
      />
      <span onClick={onPlay} className="app-option-video-play icon-play"></span>
      <span onClick={onPause} className="app-option-video-pause"></span>
    </div>
  )
};
